@if (isMobile()) {
  <app-search-widget-v4-mobile
    [hideFiltersAndPlacePanel]="hideFiltersAndPlacePanel()"
    [inferredCareProviderTypeAreaId]="inferredCareProviderTypeAreaId()"
    [inferredCategoryTypeId]="inferredCategoryTypeId()"
    [isOnTop]="isOnTop()"
    [mainCareProviderTypeId]="mainCareProviderTypeId()"
    [pageType]="pageType()"
    [theme]="theme()"
  ></app-search-widget-v4-mobile>

  @defer {
    <!--    <app-search-filters-mobile-panel></app-search-filters-mobile-panel>-->
    <app-search-widget-v4-mobile-expanded
      [inferredCareProviderTypeAreaId]="inferredCareProviderTypeAreaId()"
      [inferredCategoryTypeId]="inferredCategoryTypeId()"
      [mainCareProviderTypeId]="mainCareProviderTypeId()"
      [pageType]="pageType()"
    ></app-search-widget-v4-mobile-expanded>
  } @placeholder (minimum 2s) {
    <div class="absolute"></div>
  }
} @else {
  <app-search-widget-v2-desktop
    [customCssClass]="customCssClass()"
    [inferredCareProviderTypeAreaId]="inferredCareProviderTypeAreaId()"
    [inferredCategoryTypeId]="inferredCategoryTypeId()"
    [isOnTop]="isOnTop()"
    [mainCareProviderTypeId]="mainCareProviderTypeId()"
    [pageType]="pageType()"
    [theme]="theme()"
  >
  </app-search-widget-v2-desktop>
}

